export default __webpack_public_path__ + "static/media/a2.05d7f5d1.png";